<template>
    <div class="app" style="height: 100%;">
        <div class="text">
            <span>支付总金额</span>
            <div style="margin-top: 15px;">
                <span>￥</span>
                <span style="font-size: 45px;">{{ aaa }}</span>
            </div>
        </div>
        <div style="margin-top: 20%;">
            <van-radio-group v-model="radio">
                <div style="border: 1px solid #E7E5E7; border-radius: 10px; width: 364px; margin-left: 6%; margin-bottom: 20px;">
                    <van-radio name="1">
                        <van-image width="80" height="80" :src="weChat" style="float: left;">
                            <!-- <van-radio name="1" /> -->
                        </van-image>
                        <span>微信支付</span>
                    </van-radio>
                </div>

                <div style="border: 1px solid #E7E5E7; border-radius: 10px; width: 364px; margin-left: 6%;">
                    <van-radio name="2">
                        <van-image width="80" height="80" :src="alipay" style="float: left;">
                        </van-image>
                        <span>支付宝</span>
                    </van-radio>
                </div>
            </van-radio-group>
        </div>
        <div style="position: fixed; bottom: 10px; padding-bottom: 30px;">
            <EqButton style="width: 269px; height: 44px; margin-left: 25%;" name="立即支付"></EqButton>
        </div>
        <!-- <div>
            <van-radio-group v-model="radio">
                <van-cell-group>
                    <van-cell clickable @click="radio = '1'">
                        <van-image width="80" height="80" :src="weChat" style="float: left;">
                            <template #right-icon>
                                <van-radio name="1" />
                            </template>
                        </van-image>
                        <span>微信支付</span>

                    </van-cell>
                    <van-image width="80" height="80" :src="weChat" style="float: left;"></van-image>
                    <van-cell title="单选框 2" clickable @click="radio = '2'">
                        <template #right-icon>
                            <van-radio name="2" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div> -->

    </div>
</template>
<script>

import weChatLogo from "@/assets/myElectronicPass/weChatLogo.png";
import alipayLogo from "@/assets/myElectronicPass/alipayLogo.png";
import { RadioGroup, Radio, Image, } from 'vant';
import EqButton from "@/components/Commons/EqButton";
// import { Cell, CellGroup, } from 'vant';  "van-cell": Cell, "van-cell-group": CellGroup,

export default {
    name: "continueToPay",
    components: {
        "van-radio-group": RadioGroup, "van-radio": Radio, "van-image": Image, EqButton,
    },
    props: {

    },
    data() {
        return {
            aaa: '18.00',
            radio: '1',
            weChat: weChatLogo,
            alipay: alipayLogo,
        };
    },
    created() {

    },
    computed: {
    },
    methods: {

    },
};
</script>
<style scoped>
.text {
    text-align: center;
    margin-top: 10%;
}
</style>
  
  
  
  
  